import {RatingsRepositoriesFactory} from '../Repositories/factory.js'
import {RatingsValueObjectsFactory} from '../ValueObjects/factory.js'
import {CancelTradeRatingsUseCase} from './CancelTradeRatingsUseCase.js'

export default class RatingsUseCaseFactory {
  static cancelTradeRatingsUseCase = ({config}) =>
    new CancelTradeRatingsUseCase({
      config,
      repository: RatingsRepositoriesFactory.httpRatingsRepository({config}),
      tokenRequestValueObjectFactory: RatingsValueObjectsFactory.tokenRequestRatingsValueObject
    })
}
